import { type FC } from 'react';

import { HStack, type StackProps, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { IconRightArrow } from '../Icons';

type BackButtonProps = {
  customText?: string;
  wrapperStyles?: StackProps;
  color?: string;
  to?: string;
};

export const BackButton: FC<BackButtonProps> = ({
  customText,
  wrapperStyles = {},
  color = 'primary.500',
  to,
}) => {
  const { t } = useTranslation(['common']);
  const navigate = useNavigate();

  return (
    <HStack
      onClick={() => (to ? navigate(to) : navigate(-1))}
      mb={4}
      cursor="pointer"
      fontSize="sm"
      fontWeight="medium"
      color="brand.500"
      {...wrapperStyles}
    >
      <IconRightArrow
        fontSize="larger"
        color={color}
        transform="rotate(180deg)"
      />

      <Text>{customText ?? t('common:actions.back')}</Text>
    </HStack>
  );
};
